module.exports = __webpack_public_path__ + "static/media/mass_clientLogo.0d3e165b.png";